/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeChartLegendItem } from "../../d-chart-legend-item";
import { DThemeWhiteBase } from "./d-theme-white-base";

export class DThemeWhiteChartLegendItem extends DThemeWhiteBase implements DThemeChartLegendItem {}
